<section class="page-hero services-hero-pro">
    <div class="services-hero-bg"></div>

    <div class="container">
        <div class="services-hero-content">
            <span class="eyebrow"><i></i> Services</span>

            <h1>Integrated industrial support services.</h1>

            <p>Six core services in one strong service architecture.</p>
        </div>
    </div>
</section>

<section class="section">
    <div class="container">

        <div class="section-head">
            <div>
                <h2>Six core services in one strong service architecture.</h2>
            </div>
        </div>

        <div *ngIf="loading" class="loading-text">
            Loading services...
        </div>

        <div *ngIf="errorMessage" class="alert error">
            {{ errorMessage }}
        </div>

                <div class="capability-grid">
                    <article class="cap-card reveal" *ngFor="let s of services">
                        <div class="service-img" [ngClass]="s.iconKey">
                        </div>

                        <h3>{{ s.title }}</h3>
                        <p>{{ s.description }}</p>

                        <a class="learn" [routerLink]="s.ctaUrl || '/contact'">
                            {{ s.ctaText || 'Request service →' }}
                        </a>
                    </article>
                </div>

    </div>
</section>